import { html } from '@webtides/element-js';
import { templateFactory } from '@zeg/base-light-module/frontend/components/structures/_category-page/dropdown-sort/dropdown-sort.template';

const renderArrow = () => {
    return html`
        <div class="dropdown-arrow flex justify-center items-center">
            <svg-icon name="arrow-down" class="h-5 w-5"></svg-icon>
        </div>
    `;
};

export default templateFactory({ renderArrow });
